import gql from 'graphql-tag'

export const fetchConfigQuery = gql(`
  query {
    getPortalConfig {
      maintenance
    }
  }
`)
